import React from "react";
import { useTranslation } from "../hooks/useTranslation";

export const Features = () => {
  const { translate } = useTranslation();

  return (
    <div id="features" className="text-center">
      <div className="container">
        <div className="col-md-10 col-md-offset-1 section-title">
          <h2>{translate("features_title")}</h2>
        </div>
        <div className="row">
          <div className="col-xs-6 col-md-6">
            <i className="fa fa-comments-o"></i>
            <h3>{translate("features_1_title")}</h3>
            <p>{translate("features_1_text")}</p>
          </div>
          <div className="col-xs-6 col-md-6">
            <i className="fa fa-bullhorn"></i>
            <h3>{translate("features_2_title")}</h3>
            <p>{translate("features_2_text")}</p>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-6 col-md-6">
            <i className="fa fa-group"></i>
            <h3>{translate("features_3_title")}</h3>
            <p>{translate("features_3_text")}</p>
          </div>
          <div className="col-xs-6 col-md-6">
            <i className="fa fa-magic"></i>
            <h3>{translate("features_4_title")}</h3>
            <p>{translate("features_4_text")}</p>
          </div>
        </div>
      </div>
    </div>
  );
};
